import { RhinoError } from '../error';

export function createMissingInitRhinoError() {
  return new RhinoError('RUNTIME', 'Device Configuration is not defined. Make sure to call initRhino.');
}

export function createUserUnauthorizedError() {
  return new RhinoError('RUNTIME', 'User is not authorized');
}
